import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "task-info"
}
const _hoisted_2 = { class: "task-info__item" }
const _hoisted_3 = { class: "task-info__id" }
const _hoisted_4 = { class: "task-info__name" }
const _hoisted_5 = { class: "task-info__price" }
const _hoisted_6 = {
  key: 0,
  class: "task-info__item task-info__video"
}
const _hoisted_7 = { class: "task-info__video-title" }
const _hoisted_8 = { class: "task-info__video-desc" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 1,
  class: "task-info__item task-info__image"
}
const _hoisted_11 = ["src", "srcset"]

import { ref, onMounted, onBeforeUnmount, computed } from 'vue'

// i18n
import { useI18n } from 'vue-i18n'
import { useTaskStore, useCommonStore, useVideoStore } from '@/store'
import Conditions from '@/components/Conditions'
import Money from '@/components/ui/Money'
import VideoPreview from '@/components/VideoPreview'
import IconedText from '@/components/ui/IconedText'
import TaskControls from '@/components/TaskControls'
import { ElNotification } from 'element-plus'
import { i18n } from '@/locales/i18n'
import { getAxiosErrorText } from '@/common/helpers'

// Computed

export default /*#__PURE__*/_defineComponent({
  __name: 'TaskInfo',
  setup(__props) {

const { t } = useI18n()

// Store
const taskStore = useTaskStore()
const commonStore = useCommonStore()
const videoStore = useVideoStore()

// Components
const info = computed(() => taskStore.task?.info)
const srcset = computed<string>(() => {
  if (!info.value?.img) {
    return ''
  }
  const result = [`${info.value?.img.x1} 1x`]

  if (info.value?.img.x2) {
    result.push(`${info.value?.img.x2} 2x`)
  }

  if (info.value?.img.x3) {
    result.push(`${info.value?.img.x2} 3x`)
  }

  return result.join(', ')
})

// Methods
async function startTask() {
  const id = info.value?.id ?? ''
  commonStore.loading = true
  try {
    await taskStore.startTask(id)
    taskStore.task = await taskStore.getTask(id)
    // await taskStore.nextStep()
  } catch (e) {
    ElNotification({
      title: i18n.t('common.error'),
      message: getAxiosErrorText(e),
      type: 'error',
    })
  } finally {
    commonStore.loading = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_draw_svg = _resolveComponent("draw-svg")!

  return (info.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, "#" + _toDisplayString(info.value.id), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(info.value.name), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(info.value.priceText), 1),
            _createVNode(_unref(Money), {
              tag: "div",
              money: info.value.price
            }, null, 8, ["money"])
          ]),
          _createVNode(_unref(Conditions), {
            class: "task-info__conditions",
            conditions: info.value.conditions,
            theme: "big"
          }, null, 8, ["conditions"]),
          _createVNode(_unref(TaskControls), {
            onNextStep: startTask,
            onPrevStep: _cache[0] || (_cache[0] = ($event: any) => (_unref(taskStore).prevStep()))
          })
        ]),
        (info.value.video || info.value.link)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (info.value.video)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('task.video.title')), 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('task.video.desc')), 1),
                    _createVNode(_unref(VideoPreview), {
                      class: "task-info__video-play",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(videoStore).openVideo(info.value.video))),
                      link: info.value.video
                    }, null, 8, ["link"])
                  ], 64))
                : _createCommentVNode("", true),
              (info.value.link)
                ? (_openBlock(), _createBlock(_unref(IconedText), {
                    key: 1,
                    class: "task-info__video-link",
                    theme: ['center', 'link', 'font-default']
                  }, {
                    iconAppend: _withCtx(() => [
                      _createVNode(_component_draw_svg, {
                        name: "download",
                        width: "15",
                        height: "15"
                      })
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: info.value.link,
                        target: "_blank"
                      }, _toDisplayString(_ctx.$t('task.video.link')), 9, _hoisted_9)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (info.value.img)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("img", {
                src: info.value.img.x1,
                srcset: srcset.value
              }, null, 8, _hoisted_11)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})